// ExistingClients.js
import React from 'react';
import { motion } from 'framer-motion';
import { LogIn } from 'lucide-react';

const ExistingClients = () => {
  return (
    <section className="py-16 bg-[#F5F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
              For Existing Clients
            </h2>
            <p className="text-gray-600 text-base font-light leading-relaxed">
              If you are already working with Notapaths, please log in to your client portal to access updates, upload documents, or communicate with your assigned advisor.
            </p>
          </motion.div>

          {/* Portal Login Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-center"
          >
            <a
              href="https://app.notapaths.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#2542D4] hover:bg-[#1d34a8] text-white font-normal text-base px-8 py-4 rounded-lg transition-colors"
            >
              Client Portal Login
              <LogIn size={20} />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ExistingClients;
